import logo from '../logo.png';

const Header = () => {
  return (
    <header className="bg-gray-900 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <img 
              src={logo} 
              alt="ParkRez" 
              className="h-8 w-auto rounded-lg"
            />
            <span className="ml-3 text-white font-semibold text-lg">
              ParkRez
            </span>
          </div>
          <div className="text-gray-300 text-sm">
            Garage Onboarding
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 